export default {
    page: function() {
        this.loadTrips()
    }
}
